"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const destinations = [];
export default function DestinationGrid() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="257196" id="youtubevideo" className="py-24 text-foreground !bg-[rgba(41,126,149,1)]" ref={ref}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center">
          
          
        </div>

        <div className="max-w-4xl mx-auto mb-20">
          <AspectRatio ratio={16 / 9} className="rounded-lg overflow-hidden shadow-lg bg-muted">
            <iframe src="https://www.youtube.com/embed/PVJiSkDlL1o" title="BEWEI Video" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="w-full h-full border-0" />
          </AspectRatio>
        </div>

        <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-16 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {destinations.map((dest, i) => <Link key={dest.id} to={dest.url} data-index={i} className="block group outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-lg">
              <Card className="overflow-hidden border-border/40 shadow-md transition-all duration-500 group-hover:shadow-xl group-hover:-translate-y-2 bg-card h-full flex flex-col rounded-lg">
                <CardContent className="p-0 relative flex-grow">
                  <AspectRatio ratio={4 / 5}>
                    <img src={dest.imageSrc} data-wvc-srcset={`${dest.imageSrc}-wvc-srcset`} data-wvc-sizes={`${dest.imageSrc}-wvc-sizes`} alt={`Beauty treatment: ${dest.title}`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                    
                    {}
                    <div className="absolute inset-0 bg-gradient-to-t from-primary/60 via-transparent to-transparent opacity-60" />
                    
                    {}
                    <div className="absolute inset-0 bg-accent/0 group-hover:bg-accent/20 transition-colors duration-500 mix-blend-multiply" />
                    
                    {}
                    <div className="absolute bottom-0 left-0 p-6 w-full">
                      <h3 className="text-white font-bold text-2xl md:text-3xl drop-shadow-md font-default leading-tight">
                        {dest.title}
                      </h3>
                    </div>
                  </AspectRatio>
                </CardContent>
                
                <CardFooter className="p-5 bg-card border-t border-border/20 flex flex-col gap-2 mt-auto">
                  <div className="flex flex-wrap items-center justify-between w-full gap-4 text-xs font-mono text-muted-foreground uppercase tracking-widest">
                    <div className="flex flex-col gap-1">
                      <span className="text-[10px] text-muted-foreground/60 font-default">Fokus</span>
                      <span className="font-medium text-foreground font-default">{dest.climate}</span>
                    </div>
                    <div className="flex flex-col gap-1 text-right">
                      <span className="text-[10px] text-muted-foreground/60 font-default">Dauer</span>
                      <span className="font-medium text-foreground font-default">{dest.bestTime}</span>
                    </div>
                  </div>
                </CardFooter>
              </Card>
            </Link>)}
        </div>
      </div>
    </section>;
}